(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hro-candidate-quote_claude"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  var el = document.querySelector('[data-review-swiper]');
  if (!el) return;
  new Swiper(el, {
    pagination: { el: el.querySelector('.swiper-pagination'), clickable: true },
    autoplay: { delay: 6000, disableOnInteraction: true },
    loop: true,
    spaceBetween: 0,
    slidesPerView: 1
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hro-function-library_claude"] && !Shopify.designMode) return;
  try {
    
(function() {
  var selectedFunction = null;

  var ROLES = {
    developer: {
      roles: ['Specialist', 'Creative', 'Developer'],
      comps: ['Analysing', 'Broad thinking', 'Understanding concepts', 'Innovating', 'Forming judgements', 'Delivering solutions', 'Learning quickly', 'Systems thinking', 'Showing imagination'],
      total: 23
    },
    accountant: {
      roles: ['Specialist', 'Advisor', 'Financial specialist'],
      comps: ['Analysing', 'Financial awareness', 'Critical thinking', 'Working systematically', 'Gathering information', 'Transferring knowledge', 'Projecting credibility'],
      total: 21
    },
    manager: {
      roles: ['Organiser', 'Leader', 'Specialist'],
      comps: ['Decisiveness', 'Delegating', 'Motivating', 'Planning', 'Monitoring progress', 'Giving direction', 'Setting goals', 'Coordinating'],
      total: 22
    },
    service: {
      roles: ['Service provider', 'Administrator'],
      comps: ['Customer focus', 'Listening', 'Understanding others', 'Communicating proactively', 'Working systematically', 'Following instructions', 'Showing commitment'],
      total: 20
    }
  };

  window.hroSelectLevel = function(btn) {
    document.querySelectorAll('.level-btn').forEach(function(b) { b.classList.remove('active'); });
    btn.classList.add('active');
  };

  window.hroShowRole = function(btn, key) {
    document.querySelectorAll('.role-btn').forEach(function(b) { b.classList.remove('active'); });
    btn.classList.add('active');
    var d = ROLES[key];
    if (!d) return;
    var rest = d.total - d.comps.length;
    var roleTags = d.roles.map(function(r) { return '<span class="comp-role-tag">' + r + '</span>'; }).join('');
    var compTags = d.comps.map(function(c) { return '<span class="comp-tag">' + c + '</span>'; }).join('');
    var moreText = rest > 0 ? '<div class="comp-more">+ ' + rest + ' more competencies in the full report</div>' : '';
    document.getElementById('role-comps').innerHTML =
      '<div class="comp-section-label">Roles</div>' +
      '<div class="comp-roles">' + roleTags + '</div>' +
      '<div class="comp-section-label">Competencies</div>' +
      '<div class="comp-tags">' + compTags + '</div>' +
      moreText;
  };

  window.hroUpdateDynamicText = function() {
    var f = selectedFunction;
    var qtyInput = document.getElementById('qty-input');
    var qty = parseInt(qtyInput ? qtyInput.value : 1) || 1;

    var headline = document.getElementById('hero-headline');
    if (headline) {
      headline.textContent = f
        ? 'Selecting the right ' + f.toLowerCase() + ' — objective, fast and effortless'
        : 'Selecting the right candidate — objective, fast and effortless';
    }

    var qtyLabel = document.getElementById('qty-label');
    if (qtyLabel) {
      qtyLabel.textContent = f ? 'Number of candidates for ' + f : 'Number of candidates';
    }

    var cta = document.getElementById('cta-btn');
    if (cta) {
      cta.textContent = f ? 'Order ' + f + ' assessment →' : 'Order assessment →';
    }

    var navCta = document.getElementById('nav-cta-btn');
    if (navCta) {
      navCta.textContent = f ? 'Order ' + f + ' assessment' : 'Order assessment';
    }
  };

  window.hroSelectFunction = function(name) {
    selectedFunction = name;
    var input = document.getElementById('func-search');
    if (input) input.value = name;
    var results = document.getElementById('func-results');
    if (results) results.style.display = 'none';
    var banner = document.getElementById('func-selected-banner');
    var nameEl = document.getElementById('func-selected-name');
    if (banner) banner.style.display = 'flex';
    if (nameEl) nameEl.textContent = name;
    var prop = document.getElementById('hro-job-profile');
    if (prop) prop.value = name;
    window.hroUpdateDynamicText();
  };

  window.hroClearFunction = function() {
    selectedFunction = null;
    var input = document.getElementById('func-search');
    if (input) { input.value = ''; input.focus(); }
    var banner = document.getElementById('func-selected-banner');
    if (banner) banner.style.display = 'none';
    var prop = document.getElementById('hro-job-profile');
    if (prop) prop.value = '';
    window.hroUpdateDynamicText();
  };

  window.hroSearchFunctions = function(q) {
    var resultsEl = document.getElementById('func-results');
    if (!resultsEl) return;
    var functions = window.HRO_FUNCTIONS || [];
    q = q.trim().toLowerCase();
    if (q.length < 2) { resultsEl.style.display = 'none'; return; }
    var matches = functions.filter(function(f) {
      return f.toLowerCase().indexOf(q) !== -1;
    }).sort(function(a, b) {
      var ai = a.toLowerCase().indexOf(q);
      var bi = b.toLowerCase().indexOf(q);
      return ai !== bi ? ai - bi : a.localeCompare(b, 'en');
    });
    resultsEl.style.display = 'block';
    if (matches.length === 0) {
      resultsEl.innerHTML = '<div class="func-result-empty">No results — contact us, we\'ll help you search.</div>';
      return;
    }
    var shown = matches.slice(0, 20);
    var countText = matches.length + (matches.length === 1 ? ' profile' : ' profiles') + ' found' + (matches.length > 20 ? ' — top 20 shown' : '');
    var count = '<div class="func-result-count">' + countText + '</div>';
    var items = shown.map(function(f) {
      var lower = f.toLowerCase();
      var idx = lower.indexOf(q);
      var hi = f.slice(0, idx) + '<strong>' + f.slice(idx, idx + q.length) + '</strong>' + f.slice(idx + q.length);
      return '<div class="func-result-item" role="option" tabindex="0" onclick="hroSelectFunction(\'' + f.replace(/'/g, "\\'") + '\')" onkeydown="if(event.key===\'Enter\')hroSelectFunction(\'' + f.replace(/'/g, "\\'") + '\')">' +
        '<span class="func-result-check">✓</span><span>' + hi + '</span></div>';
    }).join('');
    resultsEl.innerHTML = count + items;
  };

  document.addEventListener('click', function(e) {
    if (!e.target.closest('.func-search-wrap')) {
      var r = document.getElementById('func-results');
      if (r) r.style.display = 'none';
    }
  });

  document.addEventListener('DOMContentLoaded', function() {
    var firstRoleBtn = document.querySelector('.role-btn.active');
    if (firstRoleBtn) window.hroShowRole(firstRoleBtn, 'developer');
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hro-header"]) return;
  try {
    
(function () {
  // ── Mobile menu ──────────────────────────────────────────────────
  var header = document.querySelector('[data-section-type="header-section"]');
  if (header) {
    var btn = header.querySelector('.hro-menu-btn');
    var nav = document.getElementById('hro-mobile-nav');
    if (btn && nav) {
      btn.addEventListener('click', function () {
        var open = header.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', String(open));
        nav.setAttribute('aria-hidden', String(!open));
        btn.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      });
    }
  }

  // ── Cart count badge ─────────────────────────────────────────────
  // Debut uses XHR for add-to-cart. Intercept XHR + fetch so we learn
  // about every cart mutation and then read the true count from /cart.js.
  var CART_MUTATE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;

  function syncCartCount(n) {
    var badge = document.querySelector('[data-hro-cart-count]');
    var link  = badge && badge.closest('.hro-cart-btn');
    if (!badge) return;
    badge.textContent = n;
    badge.classList.toggle('hro-cart-count--hidden', n === 0);
    if (link) link.setAttribute('aria-label', 'Cart (' + n + ' items)');
  }

  function refreshCount() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) { syncCartCount(c.item_count); })
      .catch(function () {});
  }

  // Intercept XHR (Debut's primary transport)
  var _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (typeof url === 'string' && CART_MUTATE.test(url)) {
      this.addEventListener('load', refreshCount);
    }
    return _open.apply(this, arguments);
  };

  // Intercept fetch (future-proof)
  if (window.fetch) {
    var _fetch = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = _fetch.apply(this, arguments);
      if (CART_MUTATE.test(url)) p.then(refreshCount).catch(function () {});
      return p;
    };
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hro-hero_claude"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var TIERS = window.HRO_TIERS;
    var BASE_PRICE = window.HRO_BASE_PRICE;
    var I18N = window.HRO_I18N || {};
    var CURRENCY = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    var LOCALE   = document.documentElement.getAttribute('lang') || 'en';
    var MONEY    = new Intl.NumberFormat(LOCALE, { style: 'currency', currency: CURRENCY });

    function getTier(n) {
      return (
        TIERS.find(function (t) {
          return n >= t.min && n <= t.max;
        }) || TIERS[TIERS.length - 1]
      );
    }

    function fmtMoney(n) {
     return MONEY.format(n);
    }



    /* Generate a v4 UUID */
    function generateUUID() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0;
        return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
      });
    }


    function updateCard(qty) {
      qty = Math.max(1, Math.min(99, parseInt(qty) || 1));
      var tier = getTier(qty);
      var total = qty * tier.unitPrice;
      var saving = qty * BASE_PRICE - total;

      var priceDisplay = document.getElementById('price-display');
      if (priceDisplay) priceDisplay.textContent = fmtMoney(total);

      var pricePer = document.getElementById('price-per');
      if (pricePer) {
        pricePer.textContent = qty > 1 ? fmtMoney(tier.unitPrice) + ' ' + (I18N.perCandidate || 'per candidate') : '';
      }

      var savingEl = document.getElementById('price-saving');
      if (savingEl) {
        if (saving > 0.01) {
          savingEl.textContent = (I18N.save || 'save') + ' ' + fmtMoney(saving);
          savingEl.style.display = 'inline-block';
        } else {
          savingEl.style.display = 'none';
        }
      }

      var rankRow = document.getElementById('ranking-row');
      if (rankRow) {
        if (tier.rankingIncluded) {
          rankRow.innerHTML =
            '<span class="inc-check"><svg viewBox="0 0 8 8" fill="none"><polyline points="1,4.5 3,6.5 7,1.5" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></span>' +
            '<strong>' + (I18N.rankingOnLabel || 'Ranking report') + '</strong> ' + (I18N.rankingOnNote || 'included');
        } else {
          rankRow.innerHTML =
            '<span class="inc-dash">–</span><span style="color:#999;">' + (I18N.rankingOff || 'Ranking report (Add a second candidate to unlock the ranking report)') + '</span>';
        }
      }

      var demoRanking = document.getElementById('demo-ranking');
      if (demoRanking) {
        demoRanking.style.opacity = tier.rankingIncluded ? '1' : '0.4';
        demoRanking.style.filter = tier.rankingIncluded ? 'none' : 'grayscale(1)';
      }

      var tierIndex = TIERS.indexOf(tier);
      for (var i = 0; i < TIERS.length; i++) {
        var seg = document.getElementById('tier-seg-' + i);
        var lbl = document.getElementById('tier-lbl-' + i);
        if (seg) seg.classList.toggle('active', i <= tierIndex);
        if (lbl) lbl.classList.toggle('active', i === tierIndex);
      }

      var variantInput = document.getElementById('hro-variant-id');
      if (variantInput) variantInput.value = tier.variantId;

      var qtyHidden = document.getElementById('hro-qty-hidden');
      if (qtyHidden) qtyHidden.value = qty;

      if (typeof hroUpdateDynamicText === 'function') hroUpdateDynamicText();
    }

    hroUpdateCard = updateCard;

    hroAdjustQty = function (delta) {
      var input = document.getElementById('qty-input');
      var val = Math.max(1, Math.min(99, (parseInt(input.value) || 1) + delta));
      input.value = val;
      updateCard(val);
    };

    hroOnQtyInput = function (input) {
      var val = parseInt(input.value);
      if (!isNaN(val) && val >= 1) updateCard(val);
    };

    hroOnQtyChange = function (input) {
      var val = Math.max(1, Math.min(99, parseInt(input.value) || 1));
      input.value = val;
      updateCard(val);
    };

    document.addEventListener('DOMContentLoaded', function () {
      updateCard(1);
       /* UUID injection — runs just before form submits */
      var form = document.getElementById('hro-cart-form');
      if (form) {
        form.addEventListener('submit', function () {
          var uuidInput = document.getElementById('hro-uuid');
          if (uuidInput) uuidInput.value = generateUUID();
          /* Form continues its normal POST — nothing else changes */
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hro-how-it-works_claude"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Step 2 and step 4 carousels
  var levelsEl = document.querySelector('[data-levels-swiper]');
  if (levelsEl) {
    new Swiper(levelsEl, {
      pagination: { el: levelsEl.querySelector('.swiper-pagination'), clickable: true },
      spaceBetween: 8,
      slidesPerView: 1
    });
  }
  var reportsEl = document.querySelector('[data-reports-swiper]');
  if (reportsEl) {
    new Swiper(reportsEl, {
      pagination: { el: reportsEl.querySelector('.swiper-pagination'), clickable: true },
      spaceBetween: 8,
      slidesPerView: 1
    });
  }

  // Step 1: a second, independent job-title search that mirrors the real
  // Job Profile Library search (hro-function-library_claude.liquid). It
  // reuses the same window.HRO_FUNCTIONS data and, on selection, calls the
  // same window.hroSelectFunction(name) so the hero headline, CTA text and
  // quantity label update exactly as if the visitor had used the main
  // search box further down the page.
  var input = document.getElementById('step1-func-search');
  var results = document.getElementById('step1-func-results');
  if (!input || !results) return;

  input.addEventListener('input', function() {
    var q = input.value.trim().toLowerCase();
    var functions = window.HRO_FUNCTIONS || [];
    if (q.length < 2) { results.style.display = 'none'; return; }
    var matches = functions.filter(function(f) {
      return f.toLowerCase().indexOf(q) !== -1;
    }).slice(0, 8);
    if (matches.length === 0) {
      results.innerHTML = '<div class="step-search-empty">No results, try the full search below.</div>';
      results.style.display = 'block';
      return;
    }
    results.innerHTML = matches.map(function(f) {
      return '<div class="step-search-item" role="option" tabindex="0">' + f + '</div>';
    }).join('');
    results.style.display = 'block';
  });

  results.addEventListener('click', function(e) {
    var item = e.target.closest('.step-search-item');
    if (!item) return;
    input.value = item.textContent;
    results.style.display = 'none';
    if (typeof window.hroSelectFunction === 'function') {
      window.hroSelectFunction(item.textContent);
    }
  });

  document.addEventListener('click', function(e) {
    if (!e.target.closest('.step-interactive')) results.style.display = 'none';
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hro-reports_claude"] && !Shopify.designMode) return;
  try {
    
(function() {
  function pushEvent(name, params) {
    try { if (typeof window.gtag === 'function') { window.gtag('event', name, params); return; } } catch (e) {}
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, params);
      }
    } catch (e) {}
  }

  /* The gallery scrolls natively. This JS is cosmetic only: it syncs the
     dots and lets you click them. If it never runs, the gallery still
     scrolls and every image stays reachable. */
  function initGallery(gallery) {
    var track = gallery.querySelector('[data-gallery-track]');
    var dots = gallery.querySelectorAll('[data-gallery-dot]');
    if (!track || !dots.length) return;

    function setActive(index) {
      for (var i = 0; i < dots.length; i++) {
        dots[i].classList.toggle('is-active', i === index);
      }
    }

    for (var i = 0; i < dots.length; i++) {
      (function(dot, index) {
        dot.addEventListener('click', function() {
          var target = track.children[index];
          if (!target) return;
          track.scrollTo({ left: target.offsetLeft - track.offsetLeft, behavior: 'smooth' });
          setActive(index);
        });
      })(dots[i], i);
    }

    var ticking = false;
    track.addEventListener('scroll', function() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function() {
        var width = track.clientWidth;
        var index = width > 0 ? Math.round(track.scrollLeft / width) : 0;
        if (index < 0) index = 0;
        if (index > dots.length - 1) index = dots.length - 1;
        setActive(index);
        ticking = false;
      });
    }, { passive: true });
  }

  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('[data-report-gallery]').forEach(initGallery);

    document.querySelectorAll('.report-download a').forEach(function(link) {
      link.addEventListener('click', function() {
        var card = link.closest('.report-card');
        var titleEl = card ? card.querySelector('.report-card__title') : null;
        pushEvent('view_sample_report', {
          report_name: titleEl ? titleEl.textContent.trim() : ''
        });
      });
    });

    var emailForm = document.querySelector('.reports-email-cta__form');
    if (emailForm) {
      emailForm.addEventListener('submit', function() {
        pushEvent('sample_reports_email_requested', {});
      });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hro-stats_claude"] && !Shopify.designMode) return;
  try {
    
(function() {
  function animateCounter(el) {
    var target = parseInt(el.dataset.target);
    var suffix = el.dataset.suffix || '';
    var duration = 1600;
    var start = performance.now();
    function step(now) {
      var progress = Math.min((now - start) / duration, 1);
      var ease = 1 - Math.pow(1 - progress, 3);
      var current = Math.floor(ease * target);
      el.textContent = current.toLocaleString('en-US') + suffix;
      if (progress < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  var started = false;
  var observer = new IntersectionObserver(function(entries) {
    if (entries[0].isIntersecting && !started) {
      started = true;
      document.querySelectorAll('.stat-val[data-target]').forEach(animateCounter);
    }
  }, { threshold: 0.3 });

  var strip = document.querySelector('.stat-strip');
  if (strip) observer.observe(strip);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hro-testimonials_claude"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  var el = document.querySelector('[data-testimonials-swiper]');
  if (!el) return;
  new Swiper(el, {
    pagination: { el: el.querySelector('.swiper-pagination'), clickable: true },
    spaceBetween: 1,
    slidesPerView: 1.05,
    autoplay: { delay: 5000, disableOnInteraction: true },
    loop: true,
    breakpoints: {
      750: {
        slidesPerView: 3,
        spaceBetween: 1,
        allowTouchMove: false,
        autoplay: false,
        loop: false
      }
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
